<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"			
			persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card style="margin: 0px;">
        <v-toolbar class="dialog-toolbar fixNotchPaddingTop" style="margin: 0px; min-height:56px; height: auto;">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
		<v-card-text style="padding: 0;" class="fixNotchPaddingTop">

            <v-skeleton-loader v-if="isLoading" type="article, actions"/>
                
						<iframe v-show="!isLoading" ref="iframe" :src="url" @load="loadCompleted()" style="border: 0; width: 100%; height: calc(100vh - 50px);"></iframe>
		</v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "./BaseModule";

export default {
	name: "ExternalContetDialog",
	mixins: [ BaseModule ],
	data() {
		return {
			isLoading: false,
			dialog: false,
			title: null,
			url: null,
		}
	},
	methods: {
		open: function(args) {

            this.isLoading = true;
			this.title = args[0];
            this.url = args[1];

			console.log("ExternalContetDialog.open() called! [ url: " + this.url + " ]");

			this.dialog = true;
		},
		isOpen: function() {
			return this.dialog;
		},
		close: function() {
            this.url = "about:blank";
			
            this.$nextTick(() => {
                this.dialog = false;
            });

		},
		loadCompleted: function() {
            this.isLoading=false;
			console.log("ExternalContetDialog - load completed!");
		}
	}
}
</script>